const jobsHosts = new Set([
  'jobs.e2f.io',
  'jobs-prod.e2f.io',
  'jobs.trustscale.ai'
]);

export const oauthRedirectsForHost = (location, fallback) => {
  if (!location || !jobsHosts.has(location.hostname)) {
    return fallback;
  }

  return {
    redirectSignIn: `${location.origin}/loading/`,
    redirectSignOut: `${location.origin}/`
  };
};
